import Backbone from '@polleverywhere/backbone'

const resultsCountHeight = function (self) {
  if (self.$el.find('.results_container').css('visibility') === 'visible') {
    return self.$el.find('.total_results_count').outerHeight()
  } else {
    return 0
  }
}

export default class Dimensions extends Backbone.Model {
  get defaults () {
    return {
      width: 0,
      height: 0,
      titleTextHeight: 0,
      headerHeight: 0,
      marginTop: 0,
      marginBottom: 0,
      marginLeft: 0,
      marginRight: 0
    }
  }

  constructor (...args) {
    super(...args)
    this.initialize = this.initialize.bind(this)
    this.width = this.width.bind(this)
    this.height = this.height.bind(this)
    this.update = this.update.bind(this)
    this.shouldShowInstructionImage = this.shouldShowInstructionImage.bind(this)
  }

  initialize (_, options) {
    if (options === null || options === undefined) {
      options = {}
    }
    this.model = options.model
    this.$el = options.$el
    this.containerWidth = options.width
    this.containerHeight = options.height
  }

  width () {
    if (this.containerWidth) {
      return this.containerWidth || 0
    } else if (this.$el) {
      return this.$el.width() || 0
    } else {
      return 0
    }
  }

  height () {
    if (this.containerHeight) {
      return this.containerHeight || 0
    } else if (this.$el) {
      return this.$el.height() || 0
    } else {
      return 0
    }
  }

  update () {
    if (!this.model) { return }

    let width = this.width()
    const height = this.height()
    if (!width || !height) return

    const windowHeight = height
    const headerHeight = this.$el.find('.chart-header').outerHeight() || 0
    let poweredByHeight = this.$el.find('viz-brandbar').outerHeight() || 0
    const totalResultsHeight = resultsCountHeight(this)
    const legendHeight = this.$el.find('.chart--legend').outerHeight() || 0

    // IE 11 in Windows 7 and 8 does not size the chart correctly when the
    // branding bar is turned off, so make the chart a little shorter.
    // See pivotal story #132727575
    if (window.navigator.userAgent && window.navigator.userAgent.indexOf('NT 6.1') > 0) {
      poweredByHeight = 31.5
    }

    const chartHeight =
      windowHeight -
      headerHeight -
      poweredByHeight -
      totalResultsHeight -
      legendHeight

    const hasChartTitle = this.$el.find('.chart-header--title .title').length
    // Get the default document font size
    // re-assign titleTextHeight if chart title exists
    let titleTextHeight = parseInt(window.getComputedStyle(document.body, null).getPropertyValue('font-size'))
    if (hasChartTitle) {
      titleTextHeight = parseFloat(this.$el.find('.chart-header--title .title').css('font-size')) || 0
    }

    if (this.shouldShowInstructionImage()) {
      width = width / 2
    }

    this.set({
      height: chartHeight,
      width,
      titleTextHeight,
      headerHeight
    })

    return this
  }

  shouldShowInstructionImage () {
    // FTPs do not allow the option to hide instruction image/activity image, if existing, from the chart view
    // Donut charts don't allow images unless results are hidden
    if (!this.model || !this.model.flashOptions) return false

    const anInstructionsImageExists = this.model.get('instruction_image_url')
    const inInstructionsDisplayState = this.model.get('display_state') === 'instructions'
    const showInstructionsImageOnBarChart = this.model.flashOptions().get('chartShowInstructionsImage') &&
        !(this.model.flashOptions().get('chart_type') === 'donut')
    const isFTP = this.model.get('type') === 'free_text_poll'

    return anInstructionsImageExists &&
      (isFTP || (inInstructionsDisplayState || showInstructionsImageOnBarChart))
  }
}
